import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "coming-soon-page" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("section", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("header", { class: "page-header" }, [
            _createElementVNode("p", { class: "eyebrow" }, "PRINTER MANAGEMENT"),
            _createElementVNode("h1", null, "Printers")
        ], -1),
        _createElementVNode("div", {
            class: "coming-soon-panel",
            role: "status"
        }, [
            _createElementVNode("span", {
                class: "coming-soon-mark",
                "aria-hidden": "true"
            }),
            _createElementVNode("h2", null, "Coming soon")
        ], -1)
    ])));
}
